import React from 'react';

import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { cssMap } from '@atlaskit/css';

import { getSourceIcon } from './getSourceIcon.tsx';
import type { Source } from './PopularQuestions.tsx';

export const SourceItemContent = ({ source }: { source: Source }) => {
	const { title, links, embeddedProduct, excerpt } = source.content ?? {};

	return (
		<Stack space="space.075">
			<Inline alignBlock="center" space="space.100">
				{getSourceIcon({ url: links?.webui, completeKey: embeddedProduct })}
				<Text weight="regular" maxLines={1}>
					{title}
				</Text>
			</Inline>
			{excerpt && (
				<Text size="small" color="color.text.subtle" maxLines={2}>
					{excerpt}
				</Text>
			)}
		</Stack>
	);
};

export const SourceItem = ({ source }: { source: Source }) => {
	const webui = source.content?.links?.webui;

	if (!webui) {
		return <SourceItemContent source={source} />;
	}

	return (
		<Anchor href={webui} rel="noopener noreferrer" xcss={styles.noUnderline}>
			<SourceItemContent source={source} />
		</Anchor>
	);
};

const styles = cssMap({
	noUnderline: { textDecoration: 'none' },
});
